import { z } from 'zod'

import { schemas } from '~interface/zod-schema'

export type Case2 = z.infer<typeof schemas.Case2>
export type CaseAutomationEventLog = z.infer<typeof schemas.CaseAutomationEventLog>
export type CaseStatusChange0 = z.infer<typeof schemas.CaseStatusChange0>
export type CaseStatus = z.infer<typeof schemas.StatusesEnum>
export const CaseStatusEnum = schemas.StatusesEnum
export type CaseWithLocation = z.infer<typeof schemas.CaseWithLocation>
export type CasesTab1 = z.infer<typeof schemas.CasesTab1>
export type CasesConfig1 = z.infer<typeof schemas.CasesConfig1>
export type CaseFilterRequest = z.infer<typeof schemas.CaseFilter>
export type NumberComparison = z.infer<typeof schemas.NumberComparison>
export type NumberComparisonOperator = z.infer<typeof schemas.NumberComparisonOperatorEnum>
export const NumberComparisonOperatorEnum = schemas.NumberComparisonOperatorEnum

export type CommentThread = z.infer<typeof schemas.CommentThread>
export type Comment = z.infer<typeof schemas.Comment>

export type DigestFrequencyEnum = z.infer<typeof schemas.DigestFrequencyEnum>
export type DocumentStep = z.infer<typeof schemas.DocumentStep>
export type AnnotatedDocument = z.infer<typeof schemas.AnnotatedDocument>

export type SortEnum = z.infer<typeof schemas.SortEnum>

export type EmailAddressResult = z.infer<typeof schemas.EmailAddressResult>

export type Identity0 = z.infer<typeof schemas.Identity0>
export type Identity1 = z.infer<typeof schemas.Identity1>
export type Identity2 = z.infer<typeof schemas.Identity2>

export function identity1ToIdentity0(i1: Identity1): Identity0 {
  return {
    id: i1.id,
    contact_id: i1.contact_id,
    handle: i1.handle,
    name: i1.name,
    image: i1.image,
    stripe_id: i1.stripe_id,
    email: i1.email,
  }
}

export type DatetimeStep = z.infer<typeof schemas.DatetimeStep>
export type Input1 = z.infer<typeof schemas.Input1>
export type IdentityStep = z.infer<typeof schemas.IdentityStep>
export type InputCreateRequest = z.infer<typeof schemas.InputCreate>
export type ValueCreateRequest = z.infer<typeof schemas.ValueCreate>
export type ValueType = z.infer<typeof schemas.ValueTypeEnum>
export const ValueTypeEnum = schemas.ValueTypeEnum

export type Notification1 = z.infer<typeof schemas.Notification1>

export type Process0 = z.infer<typeof schemas.Process0>
export type Process1 = z.infer<typeof schemas.Process1>
export const ProcessFilterStatusEnum = schemas.Status2efEnum
export type ProcessFilterStatusEnumType = z.infer<typeof schemas.Status2efEnum>
export type ProcessSummary = z.infer<typeof schemas.ProcessSummary>

export type Bill0 = z.infer<typeof schemas.Bill0>
export type BillStep1 = z.infer<typeof schemas.BillStep1>
export type ChargeSubstep = z.infer<typeof schemas.ChargeSubstep>
export type ChargeSubstepCreate = z.infer<typeof schemas.ChargeSubStepCreate>
export type Expression = z.infer<typeof schemas.Expression>
export type Form0 = z.infer<typeof schemas.Form0>
export type Task1 = z.infer<typeof schemas.Task1>
export type Section = z.infer<typeof schemas.Section>
